import React from 'react';
import styled from 'styled-components';

interface IPadlockIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<IPadlockIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Padlock = ({ user = 'landlord' }: IPadlockIconProps): JSX.Element => (
  <StyledSvg user={user} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M16.07 8H15V5s0-5-5-5-5 5-5 5v3H3.93A1.93 1.93 0 002 9.93v8.15A1.93 1.93 0 003.93 20h12.14A1.93 1.93 0 0018 18.07V9.93A1.93 1.93 0 0016.07 8zM10 16a2 2 0 112-2 2 2 0 01-2 2zm3-8H7V5.5C7 4 7 2 10 2s3 2 3 3.5z" />
  </StyledSvg>
);

export default Padlock;
